import { gql } from '@apollo/client'

export const GET_USER_CREDIT_CARDS = gql`
  query UserCreditCards {
    currentUser {
      id
      creditCards {
        id
        cardId
        brand
        last4
        expMonth
        expYear
        funding
        name
      }
    }
  }
`
export const ADDRESS_SETTINGS = gql`
  query AddressSettings {
    currentUser {
      id
      addresses {
        edges {
          node {
            id
            pk
            country
            address
            city
            state
            zipcode
            phone
            status
            email
            fullName
            isBilling
          }
        }
      }
    }
  }
`
export const BILLING_ADDRESS_SETTINGS = gql`
  query BillingAddressSettings {
    currentUser {
      id
      billingAddresses {
        edges {
          node {
            id
            pk
            country
            address
            city
            state
            zipcode
            phone
            status
            email
            fullName
            isBilling
          }
        }
      }
    }
  }
`
export const USER_BASE_DATA = gql`
  query UserBaseData {
    currentUser {
      pk
      id
      email
      type {
        name
        permissions
      }
      lastName
      firstName
      fullName
      phoneNumber
      isPhoneNumberVerified
      credit
    }
  }
`
export const GET_USER_REFERRAL_CODE = gql`
  query GetUserReferralCode {
    currentUser {
      id
      redemptionsCount
      referral {
        id
        code
      }
    }
  }
`

export const USER_FOLLOWED_ARTISTS = gql`
  query FollowedArtists {
    currentUser {
      id
      type {
        name
        permissions
      }
      followedArtists {
        edges {
          node {
            id
            slug
            fullName
            file {
              path
              extension
            }
          }
        }
      }
    }
  }
`

export const IS_USER_EXIST = gql`
  query IsUserExists($email: String!) {
    isUserExists(email: $email)
  }
`

export const GET_USER_BIDS = gql`
  query UserBids {
    currentUser {
      id
      offers {
        edges {
          node {
            id
            isWinningBid
            price
            created
            artwork {
              id
              title
              currentBid
              slug
              eventStartDate
              eventStartDateLocal
              artists {
                edges {
                  node {
                    slug
                    fullName
                  }
                }
              }
              auctionSet {
                edges {
                  node {
                    start
                    end
                  }
                }
              }
              venue {
                name
                slug
                timeZone
              }
            }
          }
        }
      }
    }
  }
`

export const GET_USER_CREDIT_HISTORY = gql`
  query GetUserCreditHistory($orderBy: String, $first: Int, $after: String) {
    currentUser {
      id
      credit
      creditHistory(orderBy: $orderBy, first: $first, after: $after) {
        edges {
          node {
            id
            amount
            summedAmount
            uid
            createdAt
            actionType {
              id
              type
            }

            data {
              __typename

              ... on ArtistNode {
                id
                fullName
                slug
              }

              ... on VenueNode {
                id
                slug
                city
                name
                state
              }
            }
          }
        }

        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
      }
    }
  }
`

export const GET_USER_BASIC_INFORMATION = gql`
  query UserBasicInformation {
    currentUser {
      id
      pk
      email
      firstName
      lastName
      type
      phoneNumber
      notifyOnNewWorks
    }
  }
`

export const GET_USER_OFFERS = gql`
  query UserOffers($artwork: ID!) {
    currentUser {
      id
      offers(artwork: $artwork, orderBy: "-id") {
        edges {
          node {
            id
            bidType
            isWinningBid
            maxBidAmount
            paymentCompletionStatus
            paymentStatus
            price
          }
        }
      }
    }
  }
`
